<div class="saveNameList">
  <div class="header">
    <img src="/assets/images/question-menu/table-field.svg" />
    <p *ngIf="!isEditMode" translate>tableField.savingField</p>
    <p *ngIf="isEditMode" translate>tableField.editingField</p>
  </div>
  <div class="contain">
    <p translate>tableField.fieldName</p>
    <div class="warp-select" #trigger>
      <div class="folder" (click)="isMenuOpen=true">
        <p *ngIf="fieldId.value; else placeholder">{{ getSelectedFieldName() }}</p>
        <ng-template #placeholder>
          <p class="placeholder" translate>tableField.selectField</p>
        </ng-template>
        <img src="/assets/images/steps/dropdown.svg" class="download-img" />
      </div>
    </div>

    <p class="warning" *ngIf="isSelectedFieldInUse" translate>tableField.alreadyUsedWarning</p>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
      cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="isMenuOpen=false"
      [cdkConnectedOverlayOpen]="isMenuOpen" [cdkConnectedOverlayPositions]="positonArea">
      <div class="overlay-warp">
        <div *ngFor="let f of tableFields()" class="item" (click)="selectField(f.id)">
          <p>{{ f.displayName }}</p>
          <span class="in-use-tag" *ngIf="isFieldInUse(f.id)" translate>tableField.inUse</span>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="footer">
    <div>
      <img *ngIf="isEditMode" class="pointer" src="/assets/images/question-menu/delete.svg" (click)="remove()" />
    </div>
    <div class="buttons">
      <div class="btn cancel pointer" (click)="cancel()" translate>
        questionBoard.edit.list-popup.cancel
      </div>
      <div [ngClass]="{ disable: !fieldId.valid }" class="btn save pointer" (click)="save()">
        <p translate>questionBoard.edit.list-popup.save</p>
      </div>
    </div>
  </div>
</div>
